<template>
  <div id="Mtr" class="q-pa-md">
    <crud-layout
        ref="crudLayout"
        :name="name"
        :interface="nmInterface"
        :id="id"
        :page-table="pageTable"
      />
      <!-- <page-table
                slot="page-table"
                slot-scope="dataPageTable"
                v-bind="dataPageTable"
                @action-button="dataPageTable.actionButton"
                @show-message="dataPageTable.showMessage"
              >
                <jt-data-table
                  slot="table"
                  slot-scope="dataTable"
                  v-bind="dataTable"
                  singleselect
                  class="table-crud"
                  :row-buttons="true"
                  @selection="dataTable.selection"
                  @action-button="dataTable.actionButton"
                  @show-message="dataTable.showMessage"
                  @toggle-change="row"
                >
                </jt-data-table>
              </page-table>
            </crud-layout> -->
      <q-dialog v-model="visible" persistent>
        <q-card>
          <q-card-section class="row justify-center">
            <q-icon name="error_outline" color="warning" size="4.5em"></q-icon>
          </q-card-section>
          <q-card-section class="row justify-center q-mx-lg">
            <span class="text-subtitle1 text-weight-medium text-center">{{ $gettext('MTR_WRITE_OFF_CONFIRM_DIALOG') }}</span>
          </q-card-section>
          <q-card-actions class="justify-center q-pa-md q-my-sm">
            <q-btn :label="$gettext('DIALOGS_NO')" color="grey-7" v-close-popup class="q-px-lg" />
            <q-btn :label="$gettext('DIALOGS_YES')" color="info" v-close-popup @click="writeOffMtr()" class="q-px-lg" />
          </q-card-actions>
        </q-card>
    </q-dialog>
  </div>
</template>
<script>

import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import { MtrRepository } from './MtrRepository'
import { repository } from 'jtech'
import {
  QDialog,
  Dialog
} from 'quasar'
import MtrPageTable from './ MtrPageTable.vue'

const { CrudLayout } = JtCrud

@Component({
  name: 'Mtr',
  components: {
    CrudLayout, QDialog, Dialog, MtrPageTable
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class Mtr extends Vue {
  visible = false;
  params = {}
  page = null

  get nmInterface () {
    return this.interface
  }

  get pageTable () {
    return MtrPageTable
  }

  async download ({ button, params, page, controller }) {
    const blob = await MtrRepository.downloadMtr(params.code)
    const fileLink = document.createElement('a')
    const fileURL = window.URL.createObjectURL(blob.data, { type: 'application/pdf' })
    fileLink.href = fileURL
    fileLink.setAttribute('download', `mtr-${params.code}.pdf`)
    document.body.appendChild(fileLink)
    fileLink.click()
    document.body.removeChild(fileLink)
  }

  async writeOffMtr () {
    const data = await repository.resolveLogic('mtr.writeOff', this.params)
    if (this.page) this.page.refresh()
  }

  openConfirmModal ({ button, params, page, controller }) {
    this.visible = true
    this.params = params
    this.page = page
  }

  mounted () {
    try {
      this.$refs.crudLayout.onButton('btExecutar', this.download)
      this.$refs.crudLayout.onButton('btConfirmar', this.openConfirmModal)
    } catch (error) {
      console.error(error)
    }
  }
}

export default Mtr

</script>

<style lang="stylus" scoped>
</style>
